// storeAccess — may a driver be made a temporary store manager? (migration 0084)
//
// A setting on the driver, not a role. Existing drivers have it; new drivers start without it and
// an admin turns it on in the Admin Panel. The database enforces the rule (a trigger on
// store_temp_managers refuses such a driver, and turning access off removes the driver from every
// store); these helpers only let the UI explain it before the database has to say no.
//
// `storeAccess` is absent on rows read before 0084 was applied, so absent means "has access":
// today's behaviour. Always read the flag through hasStoreAccess.
import type { User } from '../types';

export const NO_STORE_ACCESS_NOTE = 'No store access';

export function hasStoreAccess(user: Pick<User, 'storeAccess'> | null | undefined): boolean {
  return user?.storeAccess !== false;
}

/** Suffix for a driver's name in assign dropdowns and on the map: " (no store)" or "". */
export function noStoreSuffix(user: Pick<User, 'storeAccess'> | null | undefined): string {
  return hasStoreAccess(user) ? '' : ' (no store)';
}

/** The message shown when an assignment is refused, by the UI or by the database. */
export function noStoreAccessMessage(driverName: string | undefined): string {
  return `${driverName || 'This driver'} has no store access and cannot manage a store. An admin can turn it on in the Admin Panel.`;
}

/** Did a Supabase / PostgREST error come from the 0084 store-access trigger? */
export function isStoreAccessRefusal(error: { code?: string; message?: string } | null | undefined): boolean {
  return !!error && (error.code === '23514' || /has no store access/i.test(error.message || ''));
}
